<template>
    <div class="inline-flex justify-end">
        <input
            v-model.number="amount"
            type="number"
            step="any"
            class="rounded-l rounded-r-none "
            :disabled="type === '' || type === null || type === 'disabled'"
            @input="calculate"
        />

        <select v-model="type" class="rounded-r rounded-l-none" @change="calculate" :disabled="disabled" :title="modifierTypeTitle">
            <option value=""></option>
            <option value="fixed">$</option>
            <option value="cost_plus">$+</option>
            <option value="percent_off_price">%</option>
            <option value="margin">M%</option>
            <option v-if="pricing && !pricing.pricing_level_title.includes('Retail')" value="disabled">
                X
            </option>
        </select>
    </div>
</template>

<script>
export default {
    props: ['pricing', 'disabled'],

    data() {
        return {
            amount: null,
            type: null,
        }
    },

    methods: {
        calculate () {
            let pricing = {
                pricing_level_id: this.pricing.pricing_level_id,
                pricing_level_title: this.pricing.pricing_level_title,
                price: null,
                modifier_type: this.type,
                modifier_amount: this.roundDecimals(this.amount),
            }

            this.$emit('priceLevelUpdate', pricing);
        },
    },

    computed: {
        modifierTypeTitle () {
            if (this.type === 'fixed') {
                return 'Fixed Price';
            } else if (this.type === 'cost_plus') {
                return 'Cost Plus Amount';
            } else if (this.type === 'percent_off_price') {
                return 'Percent Off Price';
            } else if (this.type === 'disabled') {
                return 'Disabled';
            } else if (this.type === 'margin') {
                return 'Margin';
            }

            return '';
        }
    },

    watch: {
        pricing: {
            immediate: true,
            deep: true,
            handler (newValue) {
                if (!newValue || newValue.modifier_type === null) {
                    if (this.pricing.pricing_level_title.includes('Retail')) {
                        this.type = "fixed";
                        this.amount = this.pricing.price;
                    }
                } else {
                    this.type = newValue.modifier_type;
                    this.amount = this.type === 'fixed' ? newValue.price : newValue.modifier_amount;
                }
            }
        },
    }
}
</script>

<style scoped>
    input[type="number"] {
        @apply py-1 px-1;
        max-width: 75px;
        margin-right: -1px;
    }

    select:focus,
    input[type="number"]:focus {
        @apply z-10;
    }

    select {
        @apply text-sm pl-2 py-1 pr-8 border border-gray ring-green;
    }

    .price-select-sm input[type="number"],
    .price-select-sm select {
        @apply py-0;
    }
</style>
